/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.7.3",
  "buildId": "20261014-1443-e5cefd4",
  "builtAt": "2026-10-14T09:14:13.306Z"
});
